// import React, { useState } from "react";
// import styles from './fileUploadPreview.module.css';
// import TableComponent from '../../components/OtherComps/TableComponent/TableComponent'
// import { useLocation, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { getMatchedProductsThunk } from "../../redux/bomSlice";

// const FileUploadPreview = () => {
//   const location = useLocation();
//   const dispatch = useDispatch()
//   const navigate = useNavigate()
//   const { loading } = useSelector((state) => state.bom)

//   // const queryParams = new URLSearchParams(location.search);
//   // const data = JSON.parse(decodeURIComponent(queryParams.get("data")));
//   const data = location.state?.data


//   // Available keys from the data
//   const availableKeys = ["productNumber", "quantity", "manufacturer"];

//   // State to store selected column names
//   const [selectedColumns, setSelectedColumns] = useState({
//     col1: "productNumber",
//     col2: "quantity",
//     col3: "manufacturer",
//   });
//   const handleColumnChange = (column, newValue) => {
//     setSelectedColumns((prev) => {
//       const updatedColumns = { ...prev };

//       // Find the column that currently has the newValue
//       const previousColumn = Object.keys(prev).find((key) => prev[key] === newValue);

//       if (previousColumn) {
//         // Swap values
//         updatedColumns[previousColumn] = prev[column];
//       }

//       // Assign new value
//       updatedColumns[column] = newValue;

//       return updatedColumns;
//     });
//   };




//   const handleContinue = async () => {

//     const mappedData = data.map((item) => ({
//       [selectedColumns.col1]: item.productNumber?.trim(),
//       [selectedColumns.col2]: item.quantity,
//       [selectedColumns.col3]: item.manufacturer?.trim(),
//     }));

//     const encodedData = encodeURIComponent(JSON.stringify(mappedData));
//     const datas = await dispatch(getMatchedProductsThunk(mappedData))


//     if (datas.payload) {
//       if (location.state?.from == "bom") {
//         navigate(`/bomListing?data=${encodedData}`)
//       } else {
//         navigate('/ExInventoryListing', { state: mappedData })
//       }
//     }
//   }

//   return (
//     <>
//       <div className={styles.imgBread}>
//         <span>File Upload Mapping</span>
//       </div>
//       <div className={styles.fileContainer}>
//         <TableComponent
//           data={data}
//           handleContinue={handleContinue}
//           loading={loading}
//           selectedColumns={selectedColumns}
//           availableKeys={availableKeys}
//           handleColumnChange={handleColumnChange}
//         />
//       </div>
//     </>
//   )
// }

// export default FileUploadPreview

import React, { useState, useEffect } from "react";
import styles from './fileUploadPreview.module.css';
import TableComponent from '../../components/OtherComps/TableComponent/TableComponent';
import { useLocation, useNavigate } from "react-router-dom";

const FileUploadPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state?.data || [];

  const [selectedColumns, setSelectedColumns] = useState({});
  const [columnConflict, setColumnConflict] = useState({});

  useEffect(() => {
    if (data.length > 0) {
      const allColumns = new Set();
      data.forEach(row => {
        Object.keys(row).forEach(key => {
          if (key !== 'id') allColumns.add(key);
        });
      });

      const colsArray = Array.from(allColumns).sort((a, b) => {
        const numA = parseInt(a.replace(/\D/g, ''), 10);
        const numB = parseInt(b.replace(/\D/g, ''), 10);
        if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
        return a.localeCompare(b);
      });

      const headerRow = data[0] || {};
      const initialColumns = {};
      let productNumberAssigned = false;
      let quantityAssigned = false;
      let manufacturerAssigned = false;

      const getHeaderName = (col) => {
        if (headerRow && headerRow[col] !== undefined && headerRow[col] !== null) {
          return String(headerRow[col]).trim().toLowerCase();
        }
        return '';
      };

      colsArray.forEach((col, index) => {
        const header = getHeaderName(col);

        if (header) {
          if (header === 'id' || header === '#' || header.includes('s.no') || header.includes('sl no') || header.includes('serial')) {
            initialColumns[col] = "skip";
          } else if (!productNumberAssigned && (header.includes('part') || header.includes('product') || header.includes('mpn') || header.includes('item') || header.includes('sku') || header === 'pn' || header === 'name')) {
            initialColumns[col] = "productNumber";
            productNumberAssigned = true;
          } else if (!quantityAssigned && (header.includes('qty') || header.includes('quantity') || header.includes('count') || header.includes('total'))) {
            initialColumns[col] = "quantity";
            quantityAssigned = true;
          } else if (!manufacturerAssigned && (header.includes('mfg') || header.includes('manuf') || header.includes('brand') || header.includes('company') || header.includes('make'))) {
            initialColumns[col] = "manufacturer";
            manufacturerAssigned = true;
          } else {
            initialColumns[col] = "skip";
          }
        } else {
          initialColumns[col] =
            index === 0 ? "productNumber" :
              index === 1 ? "quantity" :
                index === 2 ? "manufacturer" : "skip";
        }
      });

      if (!productNumberAssigned && colsArray.length > 0) {
        const candidate = colsArray.find(c => initialColumns[c] !== 'quantity' && initialColumns[c] !== 'manufacturer' && getHeaderName(c) !== 'id');
        if (candidate) {
          initialColumns[candidate] = 'productNumber';
        } else if (colsArray[0]) {
          initialColumns[colsArray[0]] = 'productNumber';
        }
      }

      setSelectedColumns(initialColumns);
    }
  }, [data]);

  const handleColumnChange = (column, newValue) => {
    setSelectedColumns(prev => {
      const updated = { ...prev };

      // If this value (productNumber/quantity/etc) is already selected elsewhere, set that column to "skip"
      Object.entries(updated).forEach(([colKey, val]) => {
        if (colKey !== column && val === newValue && newValue !== "skip") {
          updated[colKey] = "skip";
        }
      });

      updated[column] = newValue;
      return updated;
    });
  };


  const handleContinue = () => {
    // When mapping data from file upload, skip the first row (header row with 'id', 'Name' etc.)
    const isFileUploadedData = Boolean(data.length > 0 && ('column0' in data[0] || !('productNumber' in data[0])));
    const rowsToMap = isFileUploadedData ? data.slice(1) : data;

    const mappedData = rowsToMap
      .map((item) => {
        const result = {
          productNumber: "",
          quantity: 1,
          manufacturer: ""
        };

        Object.entries(selectedColumns).forEach(([col, mapping]) => {
          if (mapping && mapping !== "skip") {
            const value = item[col];
            const processedValue = typeof value === 'string'
              ? value.trim() || null
              : value;

            if (mapping === "quantity") {
              result[mapping] = processedValue ? Number(processedValue) || 1 : 1;
            } else {
              result[mapping] = processedValue;
            }
          }
        });

        return result;
      })
      .filter(item => {
        const p = item?.productNumber ? String(item.productNumber).trim().toLowerCase() : '';
        return p && p !== 'id' && p !== '-';
      });

    if (location.state?.from === "bom") {
      navigate('/bomListing', { state: { data: mappedData } });
    } else {
      navigate('/ExInventoryListing', { state: mappedData });
    }
  };

  return (
    <>
      <div className={styles.imgBread}>
        <span>File Upload Mapping</span>
      </div>
      <div className={styles.fileContainer}>
        <TableComponent
          data={data}
          handleContinue={handleContinue}
          loading={false}
          selectedColumns={selectedColumns}
          handleColumnChange={handleColumnChange}
          columnConflict={columnConflict}
        />
      </div>
    </>
  );
};

export default FileUploadPreview;
